// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { savedPaymentProfileEntryStyles } from "@awc/Overrides/Widgets/CheckoutReviewAndSubmit/SavedPaymentProfileEntry";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { StyledButton } from "@insite/mobius/Clickable";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

savedPaymentProfileEntryStyles.tokenExFrame = {
    labelProps: {
        css: css`
            display: flex;
            column-gap: 8px;
            ${StyledButton} ${TypographyStyle} {
                font-size: ${fontConfig.fontSize.small}px;
                line-height: ${fontConfig.lineHeight.singleLineSmall};
            }
        `,
    }
};

savedPaymentProfileEntryStyles.text = {
    css: css`
        width: 100%;
    `,
}